import RandomTeams from '../../random-teams';

export class RandomRandomRouletteTeams extends RandomTeams {}

export default RandomRandomRouletteTeams;
